import { isEmpty } from 'lodash';

export const FRAddressMapper = (storeAddress) => {
  if (storeAddress?.CountryCode !== 'FR') {
    return {
      number: '',
      street: '',
      city: '',
      postalCode: '',
    };
  }

  if (isEmpty(storeAddress?.AddressFields)) {
    return {
      number: '',
      street: storeAddress?.Line1 || '',
      city: storeAddress?.City || '',
      postalCode: storeAddress?.Postcode || '',
    };
  }

  return storeAddress.AddressFields;
};
